import { Box, Typography } from "@mui/material"
import React, { useCallback, useContext, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { customPalette } from "../../../../../../../../../theme"
import {
  BOTTOM_NAVIGATION_HEIGHT,
  CustomBottomNavigation,
} from "../../../../../../../../components/buttons/navigate-button/CustomBottomNavigation"
import { IconInbox } from "../../../../../../../../components/custom-icons/icon-inbox"
import { pagesUrl } from "../../../../../../../../core/appConstants"
import { AppSideBarContext } from "../../../../../../../../core/context/AppSideBarContext/AppSideBarContext"
import { BSVariantContext } from "../../../../../../../../core/context/beem-shot/BSVariant/BSVariantContext"
import { AppNavBarContext, NavbarTypeEnum } from "../../../../../../../../core/context/nav-bar/AppNavBarContext"
import { CoverImgProjectContext } from "../../../../../../../../core/context/project/CoverImgProjectContext"
import { ProjectContext } from "../../../../../../../../core/context/project/ProjectContext"
import { resolveUrl } from "../../../../../../../../core/services/http-service"
import { BSBuildingContext } from "../../components/context/BSBuildingContext"
import { BSPatioContainer } from "./components/BSPatioContainer"

export function BSPatioPage(): React.JSX.Element {
  const navigate = useNavigate()

  const { setShowAppSide, setFullScreen } = useContext(AppSideBarContext)
  const { setTypeNavBar, setImageFile, setIcon, setTitle, setPreviousUrl, setStepHeader } = useContext(AppNavBarContext)
  const { file } = useContext(CoverImgProjectContext)
  const { project } = useContext(ProjectContext)
  const { selectedVariant } = useContext(BSVariantContext)
  const { selectedBSBuilding } = useContext(BSBuildingContext)

  useEffect(() => {
    setTypeNavBar(NavbarTypeEnum.BUILDING_HEADER)
    setImageFile(file)
    setIcon(<IconInbox sx={{ color: customPalette.black, fontWeight: "2px" }} />)
    setTitle(selectedVariant?.name ?? "")
    setPreviousUrl(
      resolveUrl(pagesUrl.BUILDING_ZONE_AND_LEVEL, [
        project?.id,
        selectedVariant?.id,
        selectedBSBuilding?.id,
        selectedBSBuilding?.bsBimModelId,
      ])
    )
    setFullScreen(false)
    if (selectedBSBuilding?.bim !== true) {
      setStepHeader(4)
    }
  }, [
    file,
    project?.id,
    selectedBSBuilding?.bim,
    selectedBSBuilding?.bsBimModelId,
    selectedBSBuilding?.id,
    selectedVariant?.id,
    selectedVariant?.name,
    setFullScreen,
    setIcon,
    setImageFile,
    setPreviousUrl,
    setStepHeader,
    setTitle,
    setTypeNavBar,
  ])

  useEffect(() => {
    setShowAppSide(false)
  }, [setShowAppSide])

  const handleValidate: () => void = useCallback(() => {
    navigate(resolveUrl(pagesUrl.BUILDING_FONDATION, [project?.id, selectedVariant?.id, selectedBSBuilding?.id]))
  }, [navigate, project?.id, selectedBSBuilding?.id, selectedVariant?.id])

  return (
    <Box display="flex" alignItems="center" flexDirection="column" gap={2}>
      <Typography variant="h5" fontWeight={600} p={3}>
        Renseigner les patios du bâtiment
      </Typography>

      <Box minWidth="70%" sx={{ pb: BOTTOM_NAVIGATION_HEIGHT }}>
        <BSPatioContainer />
      </Box>

      <CustomBottomNavigation actionLabel="Continuer" validateAction={handleValidate} />
    </Box>
  )
}
